
  import React from "react"
  import Component from "/Users/microcipcip/works/domains/microcipcip.digital/src/layouts/index.js"
  import data from "/Users/microcipcip/works/domains/microcipcip.digital/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js